<form *ngIf="!showLoading" class="form" [formGroup]="customerEligibilityWorkplaceFormGroup">

  <div *ngIf="showStateZipSection">
    <div class="row">
      <div class="col-md-12">
        <div class="location-question">
          <h2><strong>{{cfetLabels.cfet_customer_eligibility.select_workplace_desc}}</strong></h2>
        </div>
      </div>
    </div>
    <div class="row" id="row-dropdown">
      <div class="col-md-12">
        <label for="select_state">{{cfetLabels.cfet_customer_eligibility.state}}</label>
        <div class="field-group">
          <div [ngClass]="checkState ? 'dropdown-opened' : ''">
            <abs-dropdown [drId]="'select_state'" [drName]="'stateValue'" [(dropdownValue)]="stateValueOption"
              formControlName="stateValue" [optionRepeat]="stateList" (dropdownValueChange)="onChangeState($event)"
              (click)="onClickState($event)" ngDefaultControl>
            </abs-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="row form-row" id="zipcode-input" [class.error]="zipcodeError">
      <div class="col-md-12">
        <label for="zipcode">{{cfetLabels.cfet_customer_eligibility.zipcode}}</label>
        <div class="zipcode-inputbox">
          <input id="zipcode" class="zipcode" name="zipcode" tabindex="0" formControlName="zipCode" maxlength="10"
            autocomplete="off" type="text" restrict-input="restrictzipcode" (blur)="checkZip()" (input)="changeZip()">
          <div *ngIf="zipcodeError" role="alert" [attr.aria-atomic]="true" [ngClass]="{'error-msg' : (zipcodeError)}">
            <em class="icon-badgealert" aria-hidden="true"></em>
            <span *ngIf="zipcodeError">{{cfetMessages.valid_zipcode}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row" id="workplace-footer-column1">
      <div class="col-md-12">
        <button type="button" id="btn-continue" (click)="continue($event)" (keyup)="continue($event)"
          class="btn btn-alt btn-medium" tabindex="0" [disabled]="disabledContinueButton">
          {{cfetButtonLabels.button_labels.continue}}</button>
      </div>
    </div>
    <div class="row" id="workplace-footer-column2">
      <div class="col-md-12">
        <a data-dismiss="modal" (click)="cancelCreation($event)" (keyup)="cancelCreation($event)" tabindex="0"
          type="button" id="cancel_link" class="btn btn-secondary btn-clear cancel_link"><em aria-label=""></em>
          {{cfetButtonLabels.button_labels.cancel}}</a>
      </div>
    </div>
  </div>

  <div id="selected-state-zip-section" *ngIf="showSelectedStateZip">
    <div class="row">
      <div class="col-md-10 role-mobile">
        <div class="selected-state-zip-row">
          <h2><strong>{{cfetLabels.cfet_customer_eligibility.selected_statezip_desc}}
              <span id="selected-state-zip">{{selectedState}}, {{selectedZip}}:</span></strong></h2>
        </div>
      </div>
      <div class="col-md-2 icon-mobile">
        <em class="icon-misc-penL" role="img" aria-label="Edit Button" tabindex="0" (click)="editStateZip($event)"
          (keyup)="editStateZip($event)"></em>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="showSearchSection">
    <div class="col-md-12 search-workpalce">
      <label for="searchbox">{{cfetLabels.cfet_customer_eligibility.search}}</label>
      <div id="search-input" class="search-input">
        <input type="text" id="searchbox" formControlName="searchValue" tabindex="0" autocomplete="off"
          (keyup)="searchWorkplace($event)" [ngClass]="{'searched':displaySearchResult}">
        <img id="search-icon" *ngIf="!displaySearchResult" src="assets/images/D037_Search_16.png" alt="Search Icon"
          tabindex="0" (click)="searchWorkplace($event)" (keyup)="searchWorkplace($event)">
        <img id="search-icon" *ngIf="displaySearchResult" src="assets/images/D038_Search_16.png" alt="Search Icon"
          tabindex="0" (click)="searchWorkplace($event)" (keyup)="searchWorkplace($event)">
        <div id="search-result" *ngIf="displaySearchResult || noResultsFound">
          <div id="workplace-link">
            <p id="manually-enter"><a (click)="addManually($event)" (keyup)="addManually($event)"
                tabindex="0">{{cfetLabels.cfet_customer_eligibility.cannot_find_workplace}}</a></p>
          </div>
          <ul id="workplace-list" *ngIf="displaySearchResult">
            <li id="workplace-details" *ngFor="let row of workplaceList;let i= index;"
              (click)="onChangeWorkplace($event, row)" (keyup)="onChangeWorkplace($event, row)" tabindex="0">
              <p id="bold-text">{{row.org_name}}</p><br>
              <p id="gray-text">{{row.address}}, {{row.city}}, {{row.state.slice(0,2)}} {{row.zipcode}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div id="dont-see-your-workplace-section" *ngIf="showDontSeeWorkplaceManually">
    <div id="dont-see-your-workplace-container">
      <app-dont-see-your-workplace-form (showSelectedStateZipAndSearchSection)="editWorkplaceOnManualEntry($event)"
        (manualValues)="manualValues($event)" (stateAndZipPresent)="saveManualValues($event)"
        (manualeligibilitycompletionstatus)="manualCompleteStatus($event)"
        (showCancelModal)="displayCancelModal($event)">
      </app-dont-see-your-workplace-form>
    </div>
  </div>

  <div class="" id="eligibility-completion-section" *ngIf="showEligibilityCompletion">
    <div class="row">
      <div class="col-md-10 eligibility-mobile-max">
        <div class="selected-workplace">
          <label for="selected-workplace-address"
            class="selected-workplace-address"><strong>{{selectedName}}</strong></label><br>
          <label for="selected-workplace-city-state-zipcode"
            class="selected-workplace-city-state-zipcode">{{selectedAddress}}, {{selectedCity}},
            {{selectedStateInWorkplace.slice(0,2)}} {{selectedZipInWorkplace}}</label>
        </div>
      </div>
      <div class="col-md-2 eligibility-mobile-styling">
        <em class="icon-misc-penL" role="img" aria-label="Edit Button" id="icon-workplace" tabindex="0"
          (click)="editWorkplace($event)" (keyup)="editWorkplace($event)"></em>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" id="eligibility-completion">
        <app-customer-eligibility-completion (signupDoneStatus)="signupDone($event)"
          (showCancelModal)="displayCancelModal($event)">
        </app-customer-eligibility-completion>
      </div>
    </div>
  </div>

</form>

<app-custom-spinner *ngIf="showLoading"></app-custom-spinner>